module.exports = {"key":"German","submit":"Sende Feedback","hide":"Verstecken","skip":"Zur nächsten Frage springen","placeholder":"Bitte beschreibe wie du darüber denkst?"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/de.json
// module id = 439
// module chunks = 0